export enum EntityType {
  MEMBER = 'member',
  CHAPTER = 'chapter',
  PRODUCT = 'product',
  TAG = 'tag',
  CONFIG = 'config',
  VFTIREGISTRANT = 'vftiregistrant',
  SUMMITREGISTRANT = 'summitregistrant',
}



// WEBPACK FOOTER //
// ./src/common/entity/EntityType.ts